import axios from "axios"

export const alerts = {
  fetch() {
    return axios.get("/api/alerts/").then((res) => {
      return res.data as { missingStoreCodes: any[]; incongruousSdts: any[] };
    });
  },
};
